module.exports = __webpack_public_path__ + "img/sudan.ae1ca76d.svg";